import {COUNTRY,CANADA_COUNTRY} from "../helpers/variables";

export const PREMIUM_SETTING_COMMENT_AREA_INFO_MESSAGE = "Text in this field will only be viewable by ARAG users";
export const PREMIUM_SETTING_NOTES_AREA_INFO_MESSAGE = "Text in this field will appear in the policy schedule which is viewable by the solicitor users";

export const LOCAL_PHONE_NUMBER_ATE = COUNTRY == CANADA_COUNTRY ? '+1 416 342 5400' : '+44 117 917 1564';
export const LOCAL_EMAIL_ATE = COUNTRY == CANADA_COUNTRY ? 'ate@arag.ca' : 'ateunderwriting@arag.co.uk';


export const LAYOUT_FOOTER_TEXT = COUNTRY == CANADA_COUNTRY ? 
'ARAG Legal Solutions Inc. is authorized to operate in all Canadian provinces and territories, and is regulated by the relevant provincial or territorial insurance regulator, depending on where a policy is sold.' 
: 'ARAG plc is authorised and regulated by the Financial Conduct Authority (FRN452369) <br /><br />Registered Office:<br />Unit 4a, Greenway Court, Bedwas, Caerphilly CF83 8DW<br />Registered in England & Wales.<br />Company Number 02585818'; ;

export const UK_ADDRESS_PART_1 = 'ARAG plc';
export const UK_ADDRESS_PART_2 = 'Unit 4a, Greenway Court';
export const UK_ADDRESS_PART_3 = 'Bedwas, Caerphilly, CF83 8DW';
export const UK_ADDRESS_TEL = '0117 917 1680';

export const PRIVACY_URL = COUNTRY == CANADA_COUNTRY ? 'https://www.arag.ca/en/privacy-policy/' : 'https://www.arag.co.uk/cookie-policy';
export const WEBSITE_TERMS_OF_USE = COUNTRY == CANADA_COUNTRY ? 'https://www.arag.ca/en/terms-of-use/' : 'https://www.arag.co.uk/terms-and-conditions/';


export const TWITTER_URL = COUNTRY == CANADA_COUNTRY ? 'https://twitter.com/ARAG_ca' : 'https://twitter.com/ARAG_UK';
export const LINKEDIN_URL = COUNTRY == CANADA_COUNTRY ? 'https://ca.linkedin.com/company/arag-canada' : 'https://uk.linkedin.com/company/arag-legal-services-uk';
export const BLOGGER_URL = COUNTRY == CANADA_COUNTRY ? 'https://www.arag.ca/en/company-news/' : 'http://theragnbone.blogspot.gr/';
export const YOUTUBE_URL = COUNTRY == CANADA_COUNTRY ? 'https://www.youtube.com/channel/UCFfJpkKuFUJemCXX-Y2MYkQ' : 'https://www.youtube.com/channel/UC48LCy6-XbwODcGTm8MW52w';

export const POLICY_STATUS_MN_DRAFT = "Draft";
export const POLICY_STATUS_MN_LIVE = "Live";
export const POLICY_STATUS_MN_REFERRED = "Referred";
export const POLICY_STATUS_MN_REJECTED = "Rejected";
export const POLICY_STATUS_MN_CLOSED = "Closed";
export const POLICY_STATUS_MN_ABANDONED = "Abandoned";
export const POLICY_STATUS_MN_LOST = "Lost";
export const POLICY_STATUS_MN_WON = "Won";
export const POLICY_STATUS_MN_WON_RULE49 = "WonRule49";
export const POLICY_STATUS_MN_WON_WAIVER_LIMIT = "WonWaiverLimit";
export const POLICY_STATUS_MN_WON_LESS_PREMIUMPLUSDISB = "WonPremPlusDisb";
export const POLICY_STATUS_MN_ENTERED_IN_ERROR = "EnteredInError";
export const POLICY_STATUS_MN_FOURTEEN_DAY_COOLING_OFF_PERIOD = "FourteenDayCoolingOffPeriod";
export const POLICY_STATUS_MN_WON_PART36 = "WonPart36";
export const POLICY_STATUS_MN_FAILURE_TO_BEAT_LAST_OFFER = "FailureToBeatDefendantsLastFormalOffer";
export const POLICY_STATUS_MN_BELOW_THRESHOLD = "BelowThresholdNetFinancialRecovery";
export const POLICY_STATUS_MN_DISBURSEMENTS_EXCEED = "DisbursementsExceedFinancialRecovery";

export const SHOW_APPLICATION_PREMIUM_STATUSES = [POLICY_STATUS_MN_CLOSED,POLICY_STATUS_MN_LIVE,POLICY_STATUS_MN_ABANDONED,POLICY_STATUS_MN_WON,POLICY_STATUS_MN_WON_PART36,
    POLICY_STATUS_MN_LOST,POLICY_STATUS_MN_FAILURE_TO_BEAT_LAST_OFFER,POLICY_STATUS_MN_BELOW_THRESHOLD,POLICY_STATUS_MN_DISBURSEMENTS_EXCEED];

export const ALLOW_APP_FORM_EDIT_STATUSES = [POLICY_STATUS_MN_CLOSED,POLICY_STATUS_MN_LIVE,POLICY_STATUS_MN_ABANDONED,POLICY_STATUS_MN_WON,POLICY_STATUS_MN_WON_PART36,
    POLICY_STATUS_MN_LOST,POLICY_STATUS_MN_FAILURE_TO_BEAT_LAST_OFFER,POLICY_STATUS_MN_BELOW_THRESHOLD,POLICY_STATUS_MN_DISBURSEMENTS_EXCEED,POLICY_STATUS_MN_REFERRED]
    
    
export const TAX = COUNTRY == CANADA_COUNTRY ? 'Sales Tax' : 'IPT';

export const POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL = "FeeEarnerEmail"
export const POLICY_UPDATE_QUESTION_MN_FEE_EARNER_EMAIL_INTERNAL = "FeeEarnerEmailInternal"
export const POLICY_UPDATE_QUESTION_MN_LAWYERS_EMAIL_ADDRESS = "LawyersEmailAddress"
export const POLICY_UPDATE_OPT_MN_YES = "Yes";
export const POLICY_UPDATE_OPT_MN_CASE_TRANSFERRED = "CaseTransferred";
export const POLICY_UPDATE_OPT_MN_INTERNAL_TRANSFER = "InternalTransfer";

export const POLICY_UPDATE_QUESTION_CA_MN_HAS_LAWYER_CHANGED_SINCE_LAST_UPDATE = "HasLawyerChangedSinceLastUpdate";
export const POLICY_UPDATE_QUESTION_CA_MN_REASON_CASE_REPRESENTATION_CHANGED = "ReasonCaseRepresentationChanged";

export const POLICY_SCHEDULE = COUNTRY == CANADA_COUNTRY ? 'Declaration' : 'Schedule';

export const OPPONENT_QUESTION_NAME_MAPPING = {
        'ProspectsAgainstOpponent': 'prospectsOptionId',
        'IsOpponentInsured': 'insuredOptionId',
        'WhoIsTheInsurer': 'insurerOptionId',
        'NameOfInsurerOther': 'otherInsurerName',
        'OpponentNotInsuredSatisfiedHasFunds': 'satisfiedOptionId',
        'OpponentDoNotKnowInsuredSatisfiedHasFunds': 'satisfiedOptionId',
        'OpponentName': 'name',
    };	

export const AMOUNT_TRIGGER_AREA_INFO_MESSAGE = "Referral trigger can be set using the comparator operators followed by an integer: <strong>></strong>, <strong><</strong> , <strong>>=</strong>, <strong><=</strong>. Referral trigger can also be set as a range using two integers separated by a hyphen: <strong>-</strong> .";
export const UPLOAD_FILE_POLICY_UPDATE_FORM_CA_TOOLTIP = "<style>body {max-height: 100vh;} ul ul {list-style-type: circle;margin-left: 20px;} ul ul ul {list-style-type: square;margin-left: 20px;} </style>\r\n<body>\r\n<strong>Transfer to new firm documents</strong>\r\n<ul>\r\n<li>• Letter to plaintiff confirming transfer; Notice of Change of Lawyer; Notice of Intention to Act in Person; and/or Order removing lawyer from record</li>\r\n</ul>\r\n<strong>Closure Documents</strong>\r\n<ul>\r\n<li>• Abandoned\r\n<ul>\r\n<li>If pleadings issued: Full & Final Release; and Dismissal Order/Discontinuance</li>\r\n<li>If pleadings not issued: Closing letter to plaintiff</li>\r\n</ul>\r\n</li>\r\n<li>• Below Threshold Net Financial Recovery or Disbursements Exceed Financial Recovery\r\n<ul>\r\n<li>Full & Final Release; Dismissal Order/Discontinuance; and Statement of Account</li>\r\n</ul>\r\n</li>\r\n</ul>\r\n</body>";

export const ABANDONED_POLICY_STATUSES = [POLICY_STATUS_MN_ABANDONED,POLICY_STATUS_MN_LOST,];
//PREMIUM SETTINGS TYPES
export const PS_TYPE_CUSTOM = 'custom';
export const PS_TYPE_STAGED = 'staged';
export const PS_TYPE_PERCENTAGE = 'percentage';
export const PS_TYPE_DEFAULT = 'default';
//TODO : this will be replaced in the future and the values will be taken from the API
export const PS_TYPE_PERCENTAGE_CASE_TYPES =  ['Clinical Negligence',];